/* unplugin-vue-components disabled */import { render } from "./tags-group.vue?vue&type=template&id=66404c7b&scoped=true"
import script from "./tags-group.vue?vue&type=script&lang=js"
export * from "./tags-group.vue?vue&type=script&lang=js"

import "./tags-group.vue?vue&type=style&index=0&id=66404c7b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66404c7b"],['__file',"src/controls/tags-group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66404c7b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66404c7b', __exports__)) {
    api.reload('66404c7b', __exports__)
  }
  
  module.hot.accept("./tags-group.vue?vue&type=template&id=66404c7b&scoped=true", () => {
    api.rerender('66404c7b', render)
  })

}


export default __exports__